/**
 * Browser navigation and page teardown can abort an in-flight XHR. Axios uses
 * ECONNABORTED for both that case and real timeouts, so the message must also
 * be checked before deciding that the error is expected.
 */
export const isExpectedRequestCancellation = (error) => {
  const code = error?.code;
  const name = error?.name;
  const message = String(error?.message || "").toLowerCase();

  return (
    code === "ERR_CANCELED" ||
    name === "CanceledError" ||
    (code === "ECONNABORTED" && message.includes("request aborted"))
  );
};
